
import { Mixins, Component, Watch, Ref } from "vue-property-decorator";
import tablePagination from "@/mixins/tablePagination";
import loading from "@/mixins/loading";
import Resize from "@/mixins/resize";
import ETable from '@/components/ETable.vue';
import EditDialog from "./weightEditDialog.vue";
import { getWeigherTwelveHourGuideList } from "@/api/twoHour";
import { formatTextarea } from "@/utils/common";

@Component({ name: 'two-hour-components-WeightManagement', components: { ETable, EditDialog } })
export default class WeightManagement extends Mixins(tablePagination, loading, Resize) {

    columns = [
        { prop: "time", label: "时间区间", width: "120px" },
        { prop: "name", label: "时辰", width: "100px" },
        { prop: "mustDo", label: "减脂必做", width: "140px" },
        { prop: "taboo", label: "发胖雷区", width: "140px" },
        { prop: "fatLossCore", label: "减脂核心" },
        { prop: "fatLossPrinciple", label: "减脂原理" },
        { prop: "modifiedBy", label: "操作人", width: "100px" },
        { prop: "modifiedTime", label: "最后操作时间", width: "160px" },
        { prop: "action", label: "操作", width: "100px" },
    ];

    tableData = [];

    id = "";
    EditDialogVisible = false;

    mounted() {
        this.getData();
        this.windowResize(190);
    }

    getData() {
        this.showLoading();
        getWeigherTwelveHourGuideList().then((res) => {
            this.tableData = (res.data || []).map((item: any) => ({
                ...item,
                time: (item.startTime || "").slice(0, 5) + " - " + (item.endTime || "").slice(0, 5)
            }));
        }).finally(() => {
            this.hideLoading();
        });
    }

    handleEdit(row) {
        this.id = row.id;
        this.EditDialogVisible = true;
    }

    editConfirm() {
        this.getData();
        this.EditDialogVisible = false;
    }

    formatTextarea(content: string) {
        return formatTextarea(content);
    }
}
